import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function DetailItemLabel({ label, tabIndex = 0 }) {
	return (
		<Typography
			variant="heading8"
			tabIndex={tabIndex}
			aria-label={label}
			role="paragraph"
		>
			{label}
		</Typography>
	);
}

DetailItemLabel.propTypes = {
	label: PropTypes.string.isRequired,
	tabIndex: PropTypes.number,
};

export default DetailItemLabel;
